import React, { useContext } from "react";
import { IconStar, IconStarFilled } from "@tabler/icons-react";
import { View } from "@/styles/reactnative";
import { FavouriteSection } from "./styles";
import { useFavourite } from "@app/hooks";
import { ThemeContext } from "@/theme/ThemeProvider";
import { COLORS } from "@app/constants";

const Favourite = ({ item }) => {
  const { data: favourites, toggleFavourite, isLoading } = useFavourite();
  const { textw } = useContext(ThemeContext).theme.COLORS;
  
  const itemId = item?.ep_id || item?.id; // ep_id가 없으면 id 사용
  
  const isBookmarked = favourites?.find((fav) => {
    const favId = fav?.ep_id || fav?.id;
    return favId === itemId;
  });
  
  console.log('⭐ Markets Favourite 렌더링:', { 
    item: item, 
    itemId: itemId,
    isBookmarked: !!isBookmarked, 
    favouritesCount: favourites?.length,
    hasEpId: !!item?.ep_id,
    hasId: !!item?.id
  });
  
  const handleClick = async (e) => {
    e.stopPropagation(); // 부모 클릭 이벤트 방지 (테이블 행 클릭 방지)
    
    console.log('⭐ Markets Favourite 클릭됨:', item);
    
    if (isLoading) {
      console.log('⏳ 로딩 중이므로 클릭 무시');
      return;
    }
    
    console.log('🚀 Markets toggleFavourite 호출 시작...');
    try {
      await toggleFavourite(item);
      console.log('✅ Markets toggleFavourite 완료');
    } catch (error) {
      console.error('❌ Markets toggleFavourite 에러:', error);
    }
  };

  return (
    <FavouriteSection>
      <View
        onClick={handleClick}
        style={{ 
          cursor: 'pointer',
          opacity: isLoading ? 0.6 : 1
        }}
      >
        {isBookmarked ? (
          <IconStarFilled 
            size={14} 
            style={{ color: COLORS.primary }} 
          />
        ) : (
          <IconStar 
            size={14} 
            color={textw}
          />
        )}
      </View>
    </FavouriteSection>
  );
};

export default Favourite;
